import { Base } from './base.model';
import { AcrVintage } from "./acr-vintage.model";
import { Type } from "../decorators/type.decorator";

export class AcrReportingPeriod extends Base {
  public acrProjectId: number;
  public foliumId: string;
  public verificationNotes: string;
  public startDate: Date;
  public endDate: Date;
  public verificationDate: Date;
  public issuanceDate: Date;
  public calculatedIssuance: number;
  public verificationIssuance: number;
  @Type(AcrVintage) public vintages: AcrVintage[];
}
